export default function About() {
  return (
    <div className="card-container">
      <div className="card-body" style={{ lineHeight: "2" }}>
        <h3 className="card-title" style={{ fontSize: "22px" }}>
          पटना में सेपक टाकरा विश्व कप का आयोजन
        </h3>

        <p className="card-text">
          सेपक टाकरा वर्ल्ड कप 2025 का आयोजन पहली बार भारत के बिहार राज्य की
          राजधानी पटना में होने जा रहा है। यह भव्य अंतर्राष्ट्रीय खेल का आयोजन
          20 मार्च से 25 मार्च 2025 तक पाटलिपुत्र इनडोर स्टेडियम, कंकड़बाग, पटना
          में आयोजित होगा। इस प्रतियोगिता में 20 देशों की शीर्ष टीमें और खिलाड़ी
          हिस्सा लेंगे, जिनमें
          फ्रांस,इंडिया,न्यूजीलैंड,वियतनाम,इटली,पोलैंड,जापान, थाईलैंड, सिंगापुर,
          श्रीलंका,स्विट्जरलैंड,संयुक्त राज्य अमेरिका, नेपाल, ब्राजील, ईरान,चीनी
          ताइपे, म्यांमार, मलेशिया,इंडोनेशिया इस देश के खिलाड़ी इसमें शामिल हो
          रहे हैं। इस वर्ल्ड कप में पुरुष, महिला और मिक्स्ड कैटेगरी के अंतर्गत
          रेगु, डबल और क्वाड इवेंट्स होंगे, जो खेल की विविधता और टीम भावना को
          दर्शाएंगे।
        </p>
        <br />

        <h3 className="card-title" style={{ fontSize: "22px" }}>
          सेपक टाकरा: एक अनोखा खेल
        </h3>

        <p className="card-text">
          सेपक टाकरा एक अनूठा खेल है, जिसे 'किक वॉलीबॉल' भी कहा जाता है। यह खेल
          बैडमिंटन कोर्ट जैसे मैदान पर खेला जाता है, जिसमें खिलाड़ी पैर, सिर,
          छाती और घुटनों से गेंद को मारते हैं। सेपक टाकरा बैडमिंटन कोर्ट के समान
          मैदान में खेला जाता है। इस कोर्ट की लंबाई 13.40 मीटर और चौड़ाई 6.19
          मीटर होती है। मैदान को एक रेखा द्वारा दो हिस्सों में बांटा जाता है,
          जिसकी मोटाई 2 सेंटीमीटर होती है। बिहार सरकार और खेल विभाग द्वारा खेल
          अवसंरचना और 'खेलो इंडिया' पहल के तहत सभी तैयारियां जोरों पर हैं। यह
          आयोजन न केवल बिहार बल्कि भारत को वैश्विक खेल मानचित्र पर उभारने का
          अवसर है। आइए, पटना में इस खेल महाकुंभ का हिस्सा बनें और विश्व के
          सर्वश्रेष्ठ सेपक टाकरा खिलाड़ियों को खेलते देखें।
        </p>
        <br />
      </div>
    </div>
  );
}
